export const phoneReg = /^1\d{10}$/;
